import extend from 'deep-extend';
import Scrollbar from 'smooth-scrollbar';
import GlobalHeader from './../navbar/Global_Header';

export default new class {

  constructor(options) {
    const defaults = {
      scrollWrapper: '.inner-wrap',
      accordionItem: '.accordion-item',
      btnAccordionTrigger: '.btn-accordion-trigger',
      accordionContent: '.accordion-content',
      animateSpeed: 300
    };

    this.state = {
      open: false
    };

    this.options = extend({}, defaults, options);

    let elem = document.querySelector('#off-canvas-nav');
    let siteDimmer = document.querySelector('#site-dimmer');

    if (!elem){
      return;
    }

    /*
     Define nodes / elements
     */
    this.$elem = elem;
    this.$siteDimmer = siteDimmer;
    this.$scrollWrapper = this.$elem.querySelector(this.options.scrollWrapper);
    this.$accordionItems = this.$elem.querySelectorAll(this.options.accordionItem);
    this.activeAccordion = null;

    Scrollbar.init(this.$elem, options);
    this.initAccordions();
    this.bindEvents();
  }

  showDimmer(){
    this.$siteDimmer.classList.add('active');
  }

  hideDimmer(){
    if (this.$siteDimmer.classList.contains('active')) {
      this.$siteDimmer.classList.remove('active');
    }
  }

  openNav(){
    this.$elem.classList.add('open');
    GlobalHeader.$btnOffCanvas.classList.add('is-active');
    this.state.open = true;
  }

  closeNav(){
    if (this.$elem.classList.contains('open')) {
      this.$elem.classList.remove('open');
      this.state.open = false;
    }

    if (GlobalHeader.$btnOffCanvas.classList.contains('is-active')) {
      GlobalHeader.$btnOffCanvas.classList.remove('is-active');
    }

    setTimeout(() => this.closeAccordion(this.activeAccordion), this.options.animateSpeed);

  }

  toggleNav(){
    if (this.state.open === false){
      this.showDimmer();
      this.openNav();
    } else {
      this.hideDimmer();
      this.closeNav();
    }
  }

  openAccordion(parentElem, contentElem){
    let openHeight = contentElem.getAttribute('data-open-height');
    contentElem.setAttribute('style', 'height: '+openHeight+'px');
    parentElem.classList.add('active');

    this.activeAccordion = parentElem;

  }

  closeAccordion(targetElem){
    if(!targetElem) return;
    if (targetElem.classList.contains('active')) {
      let targetContent = targetElem.querySelectorAll(this.options.accordionContent)[0];

      targetElem.classList.remove('active');
      targetContent.setAttribute('style', 'height: 0px');

      this.activeAccordion = null;
    }
  }

  toggleAccordion(parentElem, contentElem){

    if (this.activeAccordion !== null){

      let isTargetActive = parentElem.isEqualNode(this.activeAccordion);
      if (isTargetActive === true) {
        this.closeAccordion(parentElem);
      } else {
        this.closeAccordion(this.activeAccordion);
        this.openAccordion(parentElem, contentElem);
      }
    } else {
      this.openAccordion(parentElem, contentElem);
    }
  }

  initAccordions(){
    let self = this;
    this.$accordionItems.forEach(function (elem, index) {

      let $accordionContent = elem.querySelectorAll(self.options.accordionContent)[0];
      let $btnAccordionTrigger = elem.querySelectorAll(self.options.btnAccordionTrigger)[0];

      if ($accordionContent){

        let contentHeight = $accordionContent.offsetHeight;

        $accordionContent.setAttribute('data-open-height', contentHeight);
        $accordionContent.setAttribute('style', 'height: 0px');

        $btnAccordionTrigger.addEventListener('click', ()=>{
          self.toggleAccordion(elem, $accordionContent)
        });

      } else {
        return;
      }
    });
  }

  bindEvents(){
    if (this.$siteDimmer){
      this.$siteDimmer.addEventListener('click', ()=>{
        this.hideDimmer();
        this.closeNav();
      });
    } else {
      return;
    }
  }
}
